module.exports = __webpack_public_path__ + "img/icon_warning_white.ecafa06f.svg";